import React from 'react';
import { RadioGroup } from '@manulife/mux';
import { Box, Typography } from '@mui/material';
import { Caution } from '@manulife/mux-cds-icons';
import { generateRadioGroupStyles, styles } from '../../../styles/input.styles';

export const CustomRadioGroup = ({ options, selected, onChange, error }) => {
  const customStyle = generateRadioGroupStyles(error);
  const errorStyles = { ...styles.error, marginTop: '16px' };

  return (
    <Box className="check">
      <RadioGroup
        values={options}
        selected={selected}
        onChange={onChange}
        direction={RadioGroup?.DIRECTION.COLUMN}
        gap="32px"
        customStyle={customStyle}
      />
      {error && (
        <Typography sx={errorStyles}>
          <Caution />
          {error}
        </Typography>
      )}
    </Box>
  );
};
